module.exports = __webpack_public_path__ + "static/img/6.1.7a2afe4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/zh/6.1.png
// module id = HqTi
// module chunks = 0